"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Full Coordination",
  description: "A comprehensive planning experience where every detail, from venue selection to final farewell, is meticulously curated for perfection.",
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/full_event_coordination.png)]",
  link: "/PortfolioPage"
}, {
  title: "Day-of Management",
  description: "Ensure your vision unfolds flawlessly. We step in to handle logistics and vendor coordination so you can remain fully present.",
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/day_of_management.png)]",
  link: "/PortfolioPage"
}, {
  title: "Corporate Styling",
  description: "Elevate your brand's presence with sophisticated event design that reflects your corporate identity and impresses every guest.",
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/corporate_event_styling.png)]",
  link: "/PortfolioPage"
}];
export default function ThePlanningJourney() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="236396" id="the-planning-journey" className="bg-background text-foreground py-24 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`mb-16 max-w-2xl transition-all duration-700 ease-out ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-default text-4xl font-light tracking-tight text-primary md:text-5xl lg:text-6xl">
            The Planning Journey
          </h2>
          <p className="mt-4 text-xl font-default font-light tracking-wide text-muted-foreground">
            Crafting atmospheres of modern ethereal luxury through intentional design and seamless execution.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 gap-6 md:grid-cols-3 transition-all duration-1000 ease-out delay-200 ${isGridVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {services.map((service, i) => <div key={i} data-index={i} className="group relative h-[450px] w-full overflow-hidden rounded-lg border-b border-border bg-transparent transition-all duration-500 hover:shadow-xl md:h-[550px]">
              {}
              <div className={`absolute inset-0 bg-cover bg-center transition-transform duration-1000 ease-out group-hover:scale-105 ${service.bgClass}`} />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/40 to-transparent transition-opacity duration-500 group-hover:bg-accent/20" />

              {}
              <div className="absolute inset-0 flex flex-col justify-end p-8">
                <div className="transform transition-transform duration-500 ease-out group-hover:-translate-y-2">
                  <h3 className="font-default text-3xl font-light text-white md:text-4xl">
                    {service.title}
                  </h3>
                  
                  {}
                  <div className="grid grid-rows-[0fr] transition-[grid-template-rows] duration-500 ease-out group-hover:grid-rows-[1fr]">
                    <div className="overflow-hidden opacity-0 transition-opacity duration-500 delay-100 group-hover:opacity-100">
                      <p className="mt-3 mb-6 text-base font-default font-light leading-relaxed text-white/90 md:text-lg">
                        {service.description}
                      </p>
                      <Button asChild variant="outline" className="border-white/40 bg-transparent text-white hover:bg-white hover:text-primary rounded-md">
                        <Link to={service.link}>
                          Explore Service <ArrowRight className="ml-2 size-4" />
                        </Link>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}